import { ScheduleAvailabilityParams } from "@/domain/dtos/params";
import { ScheduleRepository } from "@/domain/repositories";
import { ScheduleDataSource } from "../datasources/schedule";
import {
  DaySchedule,
  ScheduleAvailableDays,
  ScheduleAvailableTimes,
} from "@/domain/entities";
import { BlockScheduleDateInput } from "@/domain/dtos/inputs";
import { ScheduleAvailableTimesResponse } from "../dtos/responses";
import { ScheduleMapper } from "@/domain/mappers";

export class ScheduleRepoImpl implements ScheduleRepository {
  constructor(
    private readonly dataSource: ScheduleDataSource,
    private readonly scheduleMapper: ScheduleMapper<ScheduleAvailableTimesResponse>,
  ) {}

  async getScheduleAvailableDays(
    params: ScheduleAvailabilityParams,
  ): Promise<ScheduleAvailableDays[]> {
    const data = await this.dataSource.getScheduleAvailableDays(params);

    return data;
  }

  async getScheduleAvailableTimes(
    params: ScheduleAvailabilityParams,
  ): Promise<ScheduleAvailableTimes[]> {
    const data = await this.dataSource.getScheduleAvailableTimes(params);

    return data.map((elem) =>
      this.scheduleMapper.toScheduleAvailableTimesDomain(elem),
    );
  }

  blockScheduleDate(params: BlockScheduleDateInput): Promise<any> {
    return this.dataSource.blockScheduleDate(params);
  }

  getSpecificDaySchedules(params?: { date: string }): Promise<DaySchedule[]> {
    return this.dataSource.getSpecificDaySchedules(params);
  }

  deleteSpecificDaySchedule(id: number): Promise<unknown> {
    return this.dataSource.deleteSpecificDaySchedule(id);
  }
}
